<template>
  <div class="d-flex align-items-center colg-forminput">
    <div class="d-flex flex-column w-40">
      <label class="mb-0 fs-14 fw-500 font-mont color-344054">
        {{ label }}
        <span v-if="mandatory" class="color-red">*</span>
      </label>
      <label class="mb-0 fs-13 fw-300 font-mont color-344054 style-italic">
        {{ sublabel }}
      </label>
    </div>

    <div class="w-60">
      <div
        class="date-floating-label position-relative"
        :class="{ 'disabled-datepicker': disabled }"
        @mouseenter="hovered = true"
        @mouseleave="hovered = false"
      >
        <DatePicker
          :editable="false"
          ref="date"
          class="w-100 datefield-input"
          :class="{ 'date-error': error }"
          :placeholder="placeholder"
          :value="value"
          :disabled="disabled"
          @input="$emit('input', $event)"
          :append-to-body="false"
        />

        <img
          v-if="!disabled && value && hovered"
          class="pointer close-icon-class"
          src="../../assets/inputImgs/date-x-close.svg"
          alt="Clear"
          @click="$emit('input', '')"
        />
        <img
          v-if="!disabled"
          class="pointer new-calender-class"
          src="../../assets/inputImgs/calendar.svg"
          alt="Calendar"
          @click="$refs.date.openPopup()"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hovered: false,
    };
  },
  props: {
    mandatory: Boolean,
    showError: Boolean,
    label: String,
    placeholder: String,
    sublabel: String,
    value: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openCalendar() {
      if (this.$refs.date && typeof this.$refs.date.open === "function") {
        this.$refs.date.open();
      } else if (
        this.$refs.date &&
        this.$refs.date.$children &&
        this.$refs.date.$children[0] &&
        typeof this.$refs.date.$children[0].open === "function"
      ) {
        this.$refs.date.$children[0].open();
      }
    },
  },
};
</script>
<style>
.datefield-input .mx-input {
  cursor: pointer !important;
}

.date-error .mx-input {
  border: 1px solid red !important;
  border-radius: 8px !important;
}

.datefield-input .mx-input[disabled] {
  background: #f7f7f7;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border: unset;
}

.colg-forminput .form-control {
  padding: 10px 14px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
  width: 60%;
}
.colg-forminput .form-control:focus {
  box-shadow: none;
  color: #333333;
  background-color: #fff;
  outline: 0;
}

.slot-clear-icon {
  position: absolute;
  right: 4px;
  top: 11px;
}
.datefield-input > .mx-input-wrapper > .mx-icon-calendar {
  display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear {
  display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear:hover {
  display: none;
}

.mx-input-wrapper input::placeholder {
  color: #adaaaa;
}

.topDiv > .dateerror .mx-input {
  border: 1px solid red !important;
  border-radius: 8px !important;
}
.topDiv > .datefield-input .mx-input {
  cursor: pointer;
}
.newmodalinputbox > .dateerror .mx-input {
  border: 1px solid red !important;
  border-radius: 8px !important;
}
.newmodalinputbox > .datefield-input .mx-input {
  cursor: pointer;
}

.new-calender-class {
  position: absolute;
  right: 15px;
  top: 9px;
}

.close-icon-class {
  position: absolute;
  right: 42px;
  top: 9px;
}

.topDiv > .datefield-input .mx-input:disabled {
  background: #f7f7f7 !important;
  cursor: default;
}
.date-floating-label label {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 12px;
  color: #667085;
  font-weight: 400;
  font-family: "Lato", sans-serif;
  transition: all 0.2s ease;
  pointer-events: none;
}

.date-floating-label label.active {
  top: -10px;
  left: 13px;
  font-size: 13px;
  color: #667085;
  font-weight: 400;
  font-family: "Lato", sans-serif;
  background-color: #ffffff;
}

@media (min-width: 1029px) {
  #formsmodal .ontop .mx-datepicker-main {
    top: 40px !important;
  }
}
@media (max-width: 1028px) {
  .mx-input::placeholder {
    color: #ffffff !important;
  }
}
</style>
